module.exports = __webpack_public_path__ + "img/gstc.6a05504e.png";